import { createSelector } from "reselect";
import { RootState } from "../../types/store";

const getEntityState = ({ entity }: RootState) => entity;

export const entitySelector = createSelector([getEntityState], (entity) => entity);
